import { SAVE, VALUE_CHANGED, LOAD, NEXT, RESET, RESET_FORM_FIELDS } from './constants';

export function saveFormData() {
  return { type: SAVE };
}

export function loadFormData(payload) {
  return { type: LOAD, payload };
}

export function handleFormDataChange(propertyName, value) {
  return { type: VALUE_CHANGED, propertyName, value };
}

export function nextSlide(errors) {
  return { type: NEXT, errors };
}

export function resetFormData() {
  return { type: RESET };
}

export function resetFormFields(fields) {
  return { type: RESET_FORM_FIELDS, payload: { fields } };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOtherInsuranceCoverage/actions.js